import { Card } from "antd";
import { useTranslation } from "react-i18next";

const data = [
    {
        name: "1. New Hairs",
        t3_q1_rev: "1.225.286.000",
        t3_q1_cus: 13,
        t3_q2_rev: "211.880.000",
        t3_q2_cus: 5,
        t2_q1_rev: "3.582.488.000",
        t2_q1_cus: 46,
        t2_q2_rev: "925.075.000",
        t2_q2_cus: 12,
    },
    {
        name: "2. CNC",
        t3_q1_rev: "379.950.000",
        t3_q1_cus: 4,
        t3_q2_rev: "-",
        t3_q2_cus: "-",
        t2_q1_rev: "391.050.000",
        t2_q1_cus: 6,
        t2_q2_rev: "71.260.000",
        t2_q2_cus: "-",
    },
];

export default function BigTable() {
    const { t } = useTranslation();
    return (
        <Card title={t('sale_online.customers_by_service_group')}>

            <div className="overflow-x-auto border rounded dark:border-[#333]">
                <table className="min-w-[900px] w-full text-sm table-fixed text-gray-800 dark:text-gray-200">

                    <thead className="sticky top-0 z-10">
                        <tr className="bg-gray-200 dark:bg-[#2a2a2a] text-center font-semibold">
                            <th className="border p-2 w-[200px]" rowSpan={2}></th>
                            <th colSpan={4} className="border p-2">{t('sale_online.month_3')}</th>
                            <th colSpan={4} className="border p-2">{t('sale_online.month_2')}</th>
                        </tr>

                        <tr className="bg-gray-100 dark:bg-[#262626] text-center">
                            <th colSpan={2} className="border p-2">Q1</th>
                            <th colSpan={2} className="border p-2">Q2</th>
                            <th colSpan={2} className="border p-2">Q1</th>
                            <th colSpan={2} className="border p-2">Q2</th>
                        </tr>

                        <tr className="bg-gray-50 dark:bg-[#1f1f1f] text-center">
                            <th className="border p-2 w-[200px] whitespace-nowrap">
                                {t('sale_online.service_group')}
                            </th>

                            <th className="border p-2">{t('sale_online.revenue')}</th>
                            <th className="border p-2">{t('sale_online.customer_visits')}</th>

                            <th className="border p-2">{t('sale_online.revenue')}</th>
                            <th className="border p-2">{t('sale_online.customer_visits')}</th>

                            <th className="border p-2">{t('sale_online.revenue')}</th>
                            <th className="border p-2">{t('sale_online.customer_visits')}</th>

                            <th className="border p-2">{t('sale_online.revenue')}</th>
                            <th className="border p-2">{t('sale_online.customer_visits')}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((item, index) => (
                            <tr
                                key={index}
                                className={`
                                    ${index % 2 === 0 ? "bg-gray-50 dark:bg-[#1f1f1f]" : ""}
                                    hover:bg-gray-100 dark:hover:bg-[#2a2a2a]
                                `}
                            >
                                <td className="border p-2 font-medium whitespace-nowrap">
                                    {item.name}
                                </td>

                                <td className="border p-2 text-right">{item.t3_q1_rev}</td>
                                <td className="border p-2 text-center">{item.t3_q1_cus}</td>

                                <td className="border p-2 text-right">{item.t3_q2_rev}</td>
                                <td className="border p-2 text-center">{item.t3_q2_cus}</td>

                                <td className="border p-2 text-right">{item.t2_q1_rev}</td>
                                <td className="border p-2 text-center">{item.t2_q1_cus}</td>

                                <td className="border p-2 text-right">{item.t2_q2_rev}</td>
                                <td className="border p-2 text-center">{item.t2_q2_cus}</td>
                            </tr>
                        ))}

                        <tr className="font-bold bg-gray-200 dark:bg-[#2a2a2a]">
                            <td className="border p-2">{t('sale_online.total')}</td>

                            <td className="border p-2 text-right">1.867.692.000</td>
                            <td className="border p-2 text-center">29</td>

                            <td className="border p-2 text-right">226.600.000</td>
                            <td className="border p-2 text-center">7</td>

                            <td className="border p-2 text-right">4.281.974.000</td>
                            <td className="border p-2 text-center">62</td>

                            <td className="border p-2 text-right">1.306.035.000</td>
                            <td className="border p-2 text-center">17</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Card>
    );
}